(function() {
    var ui = fpUtil.getNamespace('ui', fp);

    ui.ResultHeader = fp.Component.extend({
        construct: function (element, config, template, parent) {
            template = template || $(element).attr('data-template') || 'component/0/result-header.html';

            this._super(element, config, template, parent);

            _.defaults(this.config, {
                enabledViews: {
                    circular: false,
                    grid: true
                },
                search: false,
                labelFavorites: fp.ui.locale('shared-favorites', 'Favorites'),
                containerClass: S.getString(fp.config.containerClass, 'container'),
                filtersLabel: fp.config.resultFiltersLabel || fp.ui.locale('shared-filters', 'Filters')
            });

            if(!this.config.layout) {
                var layout = 0;
                if(S(template).endsWith('result-header.html')) {
                    var matches = template.match(/component\/(\d)+/i);
                    layout = matches ? matches[1] : 0;
                }
                this.config.layout = 'layout-' + layout;
            }
        },
        render: function(params) {
            var self = this,
                scope = this.scope,
                $element = this.$element,
                stateManager = scope.stateManager,
                stateParams = scope.stateParams,
                $dropdownFilter,
                dropdownFilter;

            this._super(params);

            const $pager = $element.find('[data-role="pager"]').pager({
                autoInit: false
            });

            if($pager.length) {
                const uiPager = $pager.data('fp.ui.Component');
                uiPager.init(false).done(function () {
                    var limit = _.getCollectionValue(scope.limits, parseInt(scope.limit, 10), self.config.defaultLimit);
                    uiPager.render({totalItems: scope.totalItems, limit: limit});
                });
            }

            var searchConfig;
            if(this.config.search) {
                searchConfig = _.getObject(this.config.search);
            }

            $element.find('[data-role="dropdown-sort"]').dropdown({
                ariaLabel: fp.ui.locale('aria-label-dropdown-sort', 'Select sort option'),
                onChange: function(value) {
                    var stateManager = scope.stateManager;
                    value = _.getCollectionValue(scope.sorting, value, self.config.defaultSort);
                    stateManager.go(stateManager.current, {sort: value, page: 1}, {inherit: true});
                }
            });

            $element.find('[data-role="dropdown-limit"]').dropdown({
                ariaLabel: fp.ui.locale('aria-label-dropdown-limit', 'Select page limit'),
                onChange: function(value) {
                    var limit = _.getCollectionValue(scope.limits, parseInt(value, 10), self.config.defaultLimit),
                        page;

                    if(scope.totalItems && stateParams.page) {
                        page = parseInt(stateParams.page, 10);

                        if(page * limit > scope.totalItems) page = Math.ceil(scope.totalItems / limit);
                    }

                    stateManager.go(stateManager.current, {limit: limit, page: page}, {inherit: true});
                }
            });

            $dropdownFilter = $element.find('[data-role="dropdown-filter"]').dropdown({
                ariaLabel: fp.ui.locale('aria-label-dropdown-filter', 'Select filter'),
                onChange: function(value) {
                    var state = stateManager.current,
                        nextState = state,
                        params = {page: null, filter: null};

                    if(state.parent && !state.parent.abstract && state.parent != stateManager.root) {
                        nextState = state.parent;
                    }

                    if(value != 'all') {
                        params.filter = _.getCollectionValue(scope.filters, value, self.config.defaultFilter);
                        nextState = _.getObject(stateManager.get(nextState.name + '-' + S(params.filter).trimLeft('is_').s + '-param'), nextState);
                    }

                    if (stateParams.page) params.page = 1;

                    stateManager.go(nextState, params, {inherit: true});

                    if (searchConfig && searchConfig.enableAutoResize) {
                        var searchBox = self.$element.find('[data-role="search"]').data('fp.ui.Component');
                        if (searchBox) searchBox.resize();
                    }
                }
            });

            dropdownFilter = $dropdownFilter.data('fp.ui.Component');
            if(dropdownFilter && !dropdownFilter.getValue()) {
                $dropdownFilter.find('.fp-dropdown-value > .fp-value').text('Show');
            }


            if(searchConfig) {
                var $searchBox = $element.find('[data-role="search"]'),
                    searchConfig = _.defaults(searchConfig, {
                        elementSelector: $searchBox,
                        name: 'search-box',
                        disableDropdown: true,
                        persistCategoryId: true,
                        enableWindowResize: this.config.containerClass == 'container-fluid',
                        enableInherit: true
                    });

                fp.ui.loadModule(searchConfig, this)
                    .then(function (module) {
                        return module.init();
                    });
                    //commenting out focus of inputs as it affects scrolling BB #25435
                    //.done(function() {
                    //    if(!(fpConfig.disableSmartScrollResults && !fp.device.xs)) {
                    //        fpUtil.setFocus($searchBox.find('[name="fp-input-search"]'));
                    //    }
                    //});
            }

            $element
                .addClass(fpUtil.formatString('fp-{0}', this.config.layout))
                .on('click', '[data-action$="-categories"]', $.proxy(self.__toggleCategories, self))
                .on('click', '[data-action^="view-"]', function(event) {
                    event.preventDefault();

                    var $this = $(this),
                        action = $this.attr('data-action').split('view-')[1];
                    
                    if(action == 'grid' && self.config.customGridUrl) {
                        window.location.href = self.config.customGridUrl; 
                        return;
                    }
                    if(S(action).eq(scope.stateParams.display)) return;

                    $this.parent().find('[data-action^="view-"]').removeClass('fp-is-selected');
                    $this.addClass('fp-is-selected');

                    var stateParamsDisplay = scope.stateParams.display || 'circular',
                        prevDisplay = stateParamsDisplay || action,
                        params = $.extend({}, scope.stateParams),
                        state = scope.stateManager.current;

                    params.display = action;

                    if(action == 'circular') {
                        _.each(params, function(value, key) {
                            key = S(key);
                            if(key.ne('q') && !key.endsWith('_q')) return;
                            delete params[key.s];
                        });

                        delete params.page;
                        delete params.limit;
                        delete params.filter;
                        delete params.department_id;

                        if(state.parent && !state.parent.abstract) state = state.parent;
                    }
                    else if(prevDisplay == 'circular') {
                        delete params.page;
                    }
                        
                    scope.stateManager.go(state, params);
                })
                .on('click', '[data-action="print"]', function(event) {
                    event.preventDefault();

                    // load all unloaded product images before printing
                    var loaded = [];
                    $('.fp-item .fp-item-container .fp-item-content .fp-item-image img:not([data-loaded]').each(function() {
                        const deferred = $.Deferred();
                        loaded.push(deferred);

                        fp.lozad().triggerLoad($(this)[0]);
                        $(this).on('load', function() { deferred.resolve(); });
                    });

                    // print window once images are loaded
                    $.when.apply(null, loaded).done(function() {
                        if(_.isFunction(self.config.onPrint)) self.config.onPrint();
                        else window.print();

                        fp.trigger(fp.events.TRACK_EVENT, fpConstants.trackingEvents.PrintResults);
                    });
                })
                .on('click', 'a[data-action="toggle-options"]', $.proxy(self.__toggleShowOptions, self));

            this.__toggleShowOptions(null, true);
        },
        destroyChildComponents: function(persistUI) {
            if(this.rendered) {
                const searchBox = this.$element.find('[data-role="search"]').data('fp.ui.Component');
                if(searchBox) searchBox.destroy(persistUI);
            }
            this._super(persistUI);
        },
        resize: function() {
            const resize = this._super(false);
            if(resize) {
                const searchBox = this.$element.find('[data-role="search"]').data('fp.ui.Component');
                if (searchBox) searchBox.resize();
            }
        },
        __toggleCategories: function(event) {
            event.preventDefault();

            var scope = this.scope,
                showCategories = ($(event.target).attr('data-action') == 'show-categories') ? null : false,
                limit = scope.stateParams.limit ? scope.stateParams.limit : self.__getNextLimit(showCategories);

            scope.stateManager.go(scope.stateManager.current, {limit: limit, show_categories: showCategories}, {inherit: true});
        },
        __toggleShowOptions: function(event, isInit) {
            if(event) event.preventDefault();

            var $toggleOptions = this.$element.find('a[data-action="toggle-options"]'),
                $resultHeader = this.$element.find('.fp-result-header');

            if(!$toggleOptions.length) {
                $resultHeader
                    .add(document.body)
                    .addClass('fp-is-result-controls-open');
                return;
            }

            var $btnIcon = $toggleOptions.find('.fp-btn-icon'),
                scope = this.scope,
                showOptions = fpUtil.getBoolean(scope.stateParams.show_options, false);

            //don't toggle on initialize
            showOptions = isInit ? showOptions : (showOptions ? null : true);

            if (showOptions) {
                $btnIcon
                    .removeClass('fp-icon-dropdown-expand')
                    .addClass('fp-icon-dropdown-collapse');

                $resultHeader
                    .add(document.body)
                    .addClass('fp-is-result-controls-open');
            }
            else {
                $btnIcon
                    .addClass('fp-icon-dropdown-expand')
                    .removeClass('fp-icon-dropdown-collapse');

                $resultHeader
                    .add(document.body)
                    .removeClass('fp-is-result-controls-open');
            }

            if(!isInit) {
                scope.stateManager.go(scope.stateManager.current, {show_options: showOptions}, {preventDefault: true, inherit: true});
            }
        },
        __getNextLimit: function(showCategories) {
            if(!_.size(this.config.limits)) return;

            showCategories = fpUtil.getBoolean(showCategories, this.config.showCategories);

            var key = showCategories ? 'shownDepartments' : 'hiddenDepartments',
                configLimits = this.config.limits[key],
                nextLimits = configLimits.values,
                $dropdown = this.$element.find('[data-role="dropdown-limit"]'),
                currentLimit = configLimits.default,
                nextLimit = configLimits.default,
                limit;

            if ($dropdown.length) {
                var uiDropdown = $dropdown.data('fp.ui.Component');
                currentLimit = fpUtil.getValue(parseInt(uiDropdown.getValue(), 10), 0);
            }

            for (var n = 0; n < nextLimits.length; n++) {
                limit = nextLimits[n];
                if(limit > currentLimit) break;
                else nextLimit = limit;
            }

            return nextLimit;
        }
    });
})();